import four from "../assets/images/img_four.jpg";
import { Link, useMatch, useNavigate } from "react-router-dom";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import { useState, useEffect, useContext, } from 'react';
import PaginationLayout from "../components/PaginationLayout";



const PublicPhoto = () => {
  const navigate = useNavigate()

  const match = useMatch('/creator/:id/photos/public/:page');
  const { authState ,loading} = useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);
  const [state, setState] = useState({
    data: [],
    total_count: 0
  });

  const getPublicPhotos = async () => {
    const apiRes = await henceforthApi.Creator.getPhotos(match.params.id, 'PUBLIC', Number(match.params.page) - 1)
    setState(apiRes.data)
  }

  const onChangePagination = (newVal) => {
    navigate(`/creator/${match.params.id}/photos/public/${newVal}`);
  }

  useEffect(() => {
    getPublicPhotos();
  }, [match.params.page])

  return <div className="ibox animated fadeInRight">
    <div className="ibox-title d-flex align-items-center justify-content-between">
      <h5>Public Photos</h5>
    </div>
    <div className="ibox-content">
      <div className="row mt-0 mb-4">
        {state.data.map(photo => {
          return <div className="col-md-2 mt-2 mb-2">
            <div className="public-both">
              <div className="public-pic">
                {/* <img src={photo.image_url ? `${henceforthApi.API_FILE_ROOT_MEDIUM}${photo.image_url}` : four} /> */}
              </div>
            </div>
          </div>
        })}
      </div>
    </div>

    <PaginationLayout
      count={state.total_count}
      data={state.data}
      page={Number(match.params.page)}
      limit={12}
      loading={loading}
      onPageChange={(val) => onChangePagination(val)} />
  </div>
};

export default PublicPhoto;
